module.exports = __webpack_public_path__ + "static/img/header-desktop.6c5c71c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-desktop.svg
// module id = l2PT
// module chunks = 0